export default __webpack_public_path__ + "static/media/referral-hat.4e71bcfa.png";